import Route from '@ember/routing/route';

export default class AuthenticatedRepayingStudentDebtRepaymentStrategyFinderDashboardIndexRoute extends Route {
  model() {
    return this.modelFor(
      'authenticated.repaying-student-debt.repayment-strategy-finder.dashboard.index'
    );
  }
}
